import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import CommonButton from "../../common/Button";
import { FailedInputProps } from "../../../interfaces/CategoryTransactionInterface";

const FailedInput = (props: FailedInputProps) => {
    const { transactionItem, productCategoryMapping,accordionPayloadData, setAccordionPayloadData, activeAccordionIndex, accordionButtonStates,index,inputFieldDecider } = props;

    const [isTwoFields, setIsTwoFields] = useState(inputFieldDecider(transactionItem.failedCategory, transactionItem));

    useEffect(() => {
        const newIsTwoFields = inputFieldDecider(transactionItem.failedCategory, transactionItem);
        setIsTwoFields(newIsTwoFields);
    }, [inputFieldDecider, transactionItem]);

    /**
         * 
         * @param event - The event object from the input change.
         * @param item - The item object of type FailedTransactionsType
         * @param index - The index of the item in the failedCategory array.
         * @param fieldType - The type of field being changed ("from" or "to").
         * @returns void
         * @description Handles the change event for category code in the failed transaction list.
         */

    const failedCategoryChangeHandler = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        fieldType: "from" | "to"
    ) => {
        const newCategoryCode = event.target.value.trim();
        const accordionIndex = activeAccordionIndex;
        if (accordionIndex === null) return;

        setAccordionPayloadData(prev => {
            const updatedData = [...(prev[accordionIndex] || [])];
            const fieldIndex = fieldType === "from" ? 0 : 1;

            if (newCategoryCode) {
                updatedData[fieldIndex] = {
                    ...updatedData[fieldIndex],
                    categoryCode: newCategoryCode,
                };
            } else if (updatedData[fieldIndex]) {
                updatedData[fieldIndex] = { ...updatedData[fieldIndex] };
                delete updatedData[fieldIndex].categoryCode;
            }
            return {
                ...prev,
                [accordionIndex]: updatedData
            };
        });
    };

    /**
         * 
         * @param event - The event object from the input change.
         * @param index - The index of the item in the failedCategory array.
         * @param fieldType - The type of field being changed ("from" or "to").
         * @returns void
         * @description Handles the change event for publishStatus in the failed transaction list.
         */
    const failedPublishStatusChangeHandler = (
        event: SelectChangeEvent<unknown>,
        fieldType: "from" | "to"
    ) => {
        const newStatus = event.target.value as number;
        const accordionIndex = activeAccordionIndex;
        if (accordionIndex === null) return;

        setAccordionPayloadData(prev => {
            const updatedData = [...(prev[accordionIndex] || [])];
            const fieldIndex = fieldType === "from" ? 0 : 1;

            if (newStatus !== undefined) {
                updatedData[fieldIndex] = {
                    ...updatedData[fieldIndex],
                    publishStatus: newStatus,
                };
            } else if (updatedData[fieldIndex]) {
                if (!updatedData[fieldIndex].categoryCode) {
                    updatedData.splice(fieldIndex, 1);
                } else {
                    updatedData[fieldIndex] = { ...updatedData[fieldIndex] };
                    delete updatedData[fieldIndex].publishStatus;
                }
            }

            return {
                ...prev,
                [accordionIndex]: updatedData.filter(obj => obj.categoryCode || obj.publishStatus)
            };
        });
    };

    const getCurrentData = () => {
        if (activeAccordionIndex === null) return [];
        return accordionPayloadData[activeAccordionIndex] || [];
    };

    return (
        <Grid m={2}>
            {
                isTwoFields ? (
                    <>
                        <Grid container spacing={2} mb={1}>
                            <Grid item xs={12} sm={6} md={3} lg={2}>
                                <TextField
                                    label={t("category_management.from")}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    value={getCurrentData()[0]?.categoryCode || ""}
                                    onChange={(event) => failedCategoryChangeHandler(event, "from")}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} lg={2}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label" className="insided_accordion">{t("category_management.publication_status")}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        fullWidth
                                        value={getCurrentData()[0]?.publishStatus ?? ""}
                                        onChange={(event) => failedPublishStatusChangeHandler(event, "from")}
                                    >
                                        <MenuItem value={0}>0</MenuItem>
                                        <MenuItem value={1}>1</MenuItem>
                                        <MenuItem value={9}>9</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mb={1} mt={2}>
                            <Grid item xs={12} sm={6} md={3} lg={2}>
                                <TextField
                                    label={t("category_management.to")}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    value={getCurrentData()[1]?.categoryCode || ""}
                                    onChange={(event) => failedCategoryChangeHandler(event, "to")}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} lg={2}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label" className="insided_accordion">{t("category_management.publication_status")}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        fullWidth
                                        value={getCurrentData()[1]?.publishStatus ?? ""}
                                        onChange={(event) => failedPublishStatusChangeHandler(event, "to")}
                                    >
                                        <MenuItem value={0}>0</MenuItem>
                                        <MenuItem value={1}>1</MenuItem>
                                        <MenuItem value={9}>9</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <Grid container xs={12} sm={12} md={12} lg={12} spacing={2} mb={1}>
                        <Grid item xs={12} sm={6} md={3} lg={2}>
                            <TextField
                                label={t("category_management.to")}
                                variant="outlined"
                                fullWidth
                                size="small"
                                value={getCurrentData()[0]?.categoryCode || ""}
                                onChange={(event) => failedCategoryChangeHandler(event, "from")}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3} lg={2}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label" className="insided_accordion">{t("category_management.publication_status")}</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    fullWidth
                                    value={getCurrentData()[0]?.publishStatus ?? ""}
                                    onChange={(event) => failedPublishStatusChangeHandler(event, "from")}
                                >
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={9}>9</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                )
            }
            <Grid>
                <CommonButton
                    sx={{ height: 40 }}
                    functionToExecute={() => productCategoryMapping(transactionItem?.cainzProductCode, index)}
                    className=""
                    btnName={t("category_management.execute")}
                    disableCondition={
                        activeAccordionIndex !== index ||
                        accordionButtonStates[index] ||
                        !accordionPayloadData[index]?.length
                    }
                />
            </Grid>
        </Grid>
    );
};

export default FailedInput;